<template>
  <div class="container">
    <PublicHeader :totalName="Name" />
    <div class="info">
      <div class="title" v-if="Info.contentType !== '0'">{{ Info.localizationTitle }}</div>
      <div class="time" v-if="Info.contentType == '1'">{{ Info.occurrenceTime | getLocalDate }}</div>
      <div class="imgg" v-if="Info.contentType == '1'">
        <img class="iiimg" v-if="Info.image" :src="isHttp(Info.image) ? Info.image : baseUrl + Info.image">
        <img class="iiimg" v-else src="@/assets/img/new_local.jpg">
      </div>
      <div class="content ql-editor" v-html="Info.localizationContent"></div>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import systemApi from '@/api/system'
export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      baseUrl: window.baseURL,
      Info: {},
      Name: ''
    }
  },
  async mounted() {
    this.Name = this.$route.query.Name
    if (this.$route.query.id) {
      //内容类型(0隐私协议1平台公告2帮助中心)
      var res = await systemApi.getContentInfo({ contentLocalizationId: this.$route.query.id })
      this.Info = res.data
    }
  },
  methods: {
    isHttp(url) {
      return /^https?:\/\//.test(url)
    },
  }
}
</script>

<style  lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 60px 15px 15px 15px;
  background: var(--background_color);

  .info {
    .title {
      font-weight: bold;
      font-size: 17px;
      color: var(--text_color);
      line-height: 25px;
      text-align: center;
    }

    .time {
      margin-top: 10px;
      font-size: 12px;
      color: var(--ntext_color);
      text-align: center;
    }

    .imgg {
      margin-top: 20px;
      text-align: center;

      .iiimg {
        width: 100%;
      }
    }

    .content {
      margin-top: 20px;
      font-size: 14px;
      color: var(--text_color);
      line-height: 25px;
      white-space: pre-wrap;
    }
  }
}
</style>
